import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReclamacionesService {

  myAppUrl: string;

  constructor(private _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.myAppUrl = baseUrl;
  }

  getAll(estado: string) {
    return this._http.get(this.myAppUrl + 'api/Reclamacion/' + estado);
  }

  getAllByTasID(id: number) {
    return this._http.get(this.myAppUrl + 'api/reclamacion/tasacion/' + id);
  }

  getById(id: number) {
    return this._http.get(this.myAppUrl + 'api/Reclamacion/' + id + '/mono');
  }

  create(reclamacion: any) {
    return this._http.post(this.myAppUrl + 'api/Reclamacion/', reclamacion);
  }

  update(id: number, reclamacion: any): Observable<any> {
    return this._http.put(this.myAppUrl + 'api/Reclamacion/' + id, reclamacion);
  }

  close(id: number, reclamacion: any): Observable<any> {
    return this._http.put(this.myAppUrl + 'api/Reclamacion/CierreReclamacion/' + id, reclamacion);
  }

  getTasacionID(ID) {
    return this._http.get(this.myAppUrl + 'api/Tasaciones/Summary/' + ID);
  }

  getTieneReclamacion(id: number) {
    return this._http.get(this.myAppUrl + 'api/reclamacion/tieneReclamacion/' + id);
  }

  getReclamacionByPs(idps: number) {
    return this._http.get(this.myAppUrl + 'api/reclamacion/PS/' + idps);
  }

}
